export default "__VITE_ASSET__f80e6d52__"